// JsFromRoutes CacheKey 9f8cecee80ca6e103b1969de10bf7aab
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/employees'),
  edit: /* #__PURE__ */ definePathHelper('get', '/admin/employees/:id/edit'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/employees/:id'),
}
